module.exports = __webpack_public_path__ + "static/favicons/mstile-310x150-da9dc4309d32debfe91e60955da3ff6a.png";